import React, { FC, useEffect, useState } from 'react';

import { useHistory } from 'react-router-dom';

import StatCard, { StatCardProps } from '@components/elements/StatCard';

type DataStatCardValue = string | number | any;

interface DataStatCardProps extends Omit<StatCardProps, 'value'> {
  dataKey?: string | string[] | null;
  fetch: (_query?: string) => Promise<DataStatCardValue> | DataStatCardValue;
  href?: string;
  value?: StatCardProps['value'];
}

const DataStatCard: FC<DataStatCardProps> = ({
  dataKey = null,
  href,
  fetch: fetchFn,
  value,
  ...props
}) => {
  const history = useHistory();
  // const { data, error } = useSWR<DataStatCardValue>(dataKey, fetchFn, {
  //   onError: (err) => {
  //     console.error('DataStatCard', err);
  //   },
  // });
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    const init = async () => {
      const res = await fetchFn?.();
      setData(res);
    };
    init();
  }, [fetchFn]);

  let displayValue: DataStatCardValue = '...';
  if (value) displayValue = value;
  // else if (error) displayValue = 'Failed to fetch data';
  else if (data !== undefined) displayValue = data;
  return (
    <StatCard
      {...props}
      onClick={href ? () => history.push(href) : undefined}
      value={displayValue.toString?.()}
    />
  );
};

export default DataStatCard;
